import React from "react"
import { localizer } from "../../../../Translator"

import Typography from '@material-ui/core/Typography';
import { Button } from  "@material-ui/core";
import Alert from '@material-ui/lab/Alert'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import ProductSelector from './ProductSelector'
import { Backdrop, CircularProgress } from "@material-ui/core"

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom";

import ScreenHeading from '../../../common/ScreenHeading';

/**
 * Panel for product type selection for a shipment.
 */
export class OutboxProduct extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Represents global shipment list given by parent component to be updated
      shipments: [],

      // List of available product types for the user to send a shipment.
      // The objects to be in this array are ProductInfo plus an additional field to flag 
      // each product type as currently active, ie. currently selected.
      products: [],

      // Represents the currently selected product type.
      productCode: null,

      // Success or error message on failure trying to load a product.
      productError: null,

      // Waiting for server response indicator.
      isLoading: false
    }
  }

  /**
   * Product selectors are placed in the panel for those products available for the user.
   * Adding "active" attribute to determine the product selected
   */
  componentDidMount() {
    this.setState({ shipments: this.props.shipments }, () => {
      let shipment = this.state.shipments && this.state.shipments.length > 0 ? this.state.shipments[0] : null
      if (!shipment) return
      if (!this.props.products) return

      let products = this.props.products.map(product => {
        if (product.productCode === shipment.features.productCode) {
          product.active = true
          return product
        }

        product.active = false
        return product
      })
      this.setState({ products: products, productCode: shipment.features.productCode, productError: null })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipments === this.props.shipments) return

    this.setState({ shipments: this.props.shipments }, () => {
      let shipment = this.state.shipments && this.state.shipments.length > 0 ? this.state.shipments[0] : null
      if (!shipment) return

      let products = this.props.products.map(product => {
        if (product.productCode === shipment.features.productCode) {
          product.active = true
          return product
        }

        product.active = false
        return product
      })
      this.setState({ products: products, productCode: shipment.features.productCode, productError: null })
    })
  }
  
  /**
   * Sends component data to update parent component state
   */
  handleStep = (event) => {
    if (!this.state.productCode) {
      this.setState({ productError: localizer.ShipmentWithoutProduct })
    } else {
      var direction = event ? event.currentTarget.name : "next"
      this.props.handleOutboxState(this.state.shipments, null, 1, direction, null)
    }
  }
  

  /**
  * Called when the user selects a product type.
  */
  handleSelectProduct = async (productCode) => {
    let products = this.state.products.map(product => {
      if (product.productCode === productCode) {
        product.active = true
        return product
      }

      product.active = false
      return product
    })

    const shipments = await Promise.all(
      this.state.shipments.map(async shipment => {
        shipment.features.productCode = productCode
        const price = await this.props.calculateShipmentPrice(shipment)

        let shipmentaux = { ...shipment, features: { ...shipment.features, price: price, printColor: null, printDuplex: null } }

        return shipmentaux
      })
    )
    this.setState({ shipments: shipments, products: products, productCode: productCode }, this.handleStep)
  }

  handleonClose = () => {
    this.setState({ productError: null })
  }
  
  render() {
    return (
      <React.Fragment>
        <Container className="pt-20">
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-envelopes-bulk icon-button-header mr-20 ml-20"></i>} title={localizer.ProductTypeSelectionHeaderTitle} />
         
          <Grid item md={12}>
            <Alert severity="info">
              <Typography className="typography-generic color-info" variant="caption" display="inline" gutterBottom>{localizer.ProductTypeSelectionHeaderText}</Typography>
            </Alert>
          </Grid>
          <Grid container direction="row" justify="flex-start" className="container-generic">
            {this.state.products && this.state.products.map((product) => {
              return (<ProductSelector key={product.productCode}
                productCode={product.productCode}
                description={product.description}
                subtitle={product.subtitle}
                active={product.active}
                handleSelectProduct={this.handleSelectProduct}>
              </ProductSelector>)
            })}
          </Grid>

          <Grid container direction="row" justify="flex-end" className="pt-20">
            <Button className="button-generic primary" variant="contained" name="next" onClick={this.handleStep}>{localizer.Next}</Button>
          </Grid>
        </Container>

        {/* Deletion failure notification. */}
        <SnackbarCustom message={this.state.productError} severity="error" handleonClose={this.handleonClose} />
      
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/product/OutboxProduct.js